import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img8 from '../Diagnostico/img8.jpg'
import img9 from '../Diagnostico/img9.jpg'
import img10 from '../Diagnostico/img10.jpg'
import img11 from '../Diagnostico/img11.jpg'
import img12 from '../Diagnostico/img12.jpg'
import img13 from '../Diagnostico/img13.jpg'
import img14 from '../Diagnostico/img14.jpg'
import img15 from '../Diagnostico/img15.jpg'
import img16 from '../Diagnostico/img16.jpg'
import img17 from '../Diagnostico/img17.jpg'
import img18 from '../Diagnostico/img18.jpg'
import img24 from '../Diagnostico/img24.jpg'

export class FeDiagnosis extends Component {
    render() {
        const diagnosticItems = [
            { img: img24, title: "Stethoscope accessories" },
            { img: img10, title: "Aneroid sphygmomanometer" },
            { img: img11, title: "Aneroid sphygmomanometer" },
            { img: img12, title: "Aneroid sphygmomanometer" },
            { img: img13, title: "Aneroid sphygmomanometer" },
            { img: img14, title: "Aneroid sphygmomanometer" },
            { img: img15, title: "Aneroid sphygmomanometer" },
            { img: img8,  title: "Mercury sphygmomanometer" },
            { img: img17, title: "Aneroid sphygmomanometer" },
            { img: img18, title: "Aneroid sphygmomanometer" },
            { img: img16, title: "Aneroid sphygmomanometer" },
            { img: img9,  title: "Pedestal sphygmomanometer" }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Diagnosis</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/en/FeDiagnosis2">{2}</Pagination.Item>
                    </Pagination>

                    {/* Implementación de Grid para mantener el estándar estético */}
                    <Row xs={1} md={2} lg={4} className="g-4 text-center">
                        {diagnosticItems.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow-sm border-0">
                                    <Card.Img 
                                        variant="top" 
                                        src={item.img} 
                                        style={{ objectFit: 'contain', height: '250px', padding: '10px' }} 
                                    />
                                    <Card.Body className="d-flex align-items-center justify-content-center">
                                        <Card.Title style={{ fontSize: '1.2rem' }}>{item.title}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/en/FeDiagnosis2">{2}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}